export const getClassSelector = (index: number) => {
  switch (index) {
    case 0:
      return 'grid__column1'
    case 1:
      return 'grid__column2'
    case 2:
      return 'grid__column3'

    default:
      return ''
  }
}
